// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__35C6J","form__wrapper":"Form_form__wrapper__3CPBz","form__radioWrapper":"Form_form__radioWrapper__IQZfP"};